var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic",
    clipPath: "url(#clip0_235_2706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.8334 8.3335V10.0002C15.8334 11.5473 15.2188 13.031 14.1248 14.125C13.0308 15.2189 11.5471 15.8335 10 15.8335M10 15.8335C8.45292 15.8335 6.96919 15.2189 5.87523 14.125C4.78127 13.031 4.16669 11.5473 4.16669 10.0002V8.3335M10 15.8335V19.1668M6.66669 19.1668H13.3334M10 0.833496C9.33698 0.833496 8.70109 1.09689 8.23225 1.56573C7.76341 2.03457 7.50002 2.67045 7.50002 3.3335V10.0002C7.50002 10.6632 7.76341 11.2991 8.23225 11.7679C8.70109 12.2368 9.33698 12.5002 10 12.5002C10.6631 12.5002 11.2989 12.2368 11.7678 11.7679C12.2366 11.2991 12.5 10.6632 12.5 10.0002V3.3335C12.5 2.67045 12.2366 2.03457 11.7678 1.56573C11.2989 1.09689 10.6631 0.833496 10 0.833496Z",
    stroke: "#667085",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_2706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.23e4c9493e7917d2ec89ea3926008bc7.svg";
export { ForwardRef as ReactComponent };